/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  IRetentionDataItem,
  // eslint-disable-next-line no-unused-vars
  IRetentionParams,
} from '@dashboardWirelineRetentionDepartment/RetentionManagerDepartment.models';
import getDeclinedEngagements from '@dashboardWirelineRetentionDepartment/GetDeclinedEngagements/api.service';

export interface IState {
  data: IRetentionDataItem;
  isLoading: boolean;
  error: object | null;
}

const initialState: IState = {
  data: {},
  isLoading: false,
  error: null,
};

export const getDeclinedEngagementsAction = createAsyncThunk(
  'getDeclinedEngagementsAction',
  async ({ controller, params }: { controller: AbortController, params: IRetentionParams },
    { rejectWithValue }) => {
    try {
      const { signal } = controller;
      const { data } = await getDeclinedEngagements(signal, params);
      return data;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

const DeclinedEngagementsSlice = createSlice({
  name: 'getDeclinedEngagements',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getDeclinedEngagementsAction.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getDeclinedEngagementsAction.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(getDeclinedEngagementsAction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error;
        state.data = {};
      });
  },
});

export const getDeclinedEngagementsReducer = DeclinedEngagementsSlice.reducer;
